import USER_TYPES from '@/constants/authorization/user-types'

export default [
  {
    title: 'navigation.reports',
    userTypes: [USER_TYPES.BRANCH_ADMIN, USER_TYPES.KITCHEN_WAITER, USER_TYPES.AUDITOR],
    svgIcon: 'icon-reports',
    children: [
      {
        title: 'navigation.gain-and-loss',
        svgIcon: 'icon-gain-and-loss',
        route: 'admin:reports:gain-and-loss',
        userTypes: [USER_TYPES.BRANCH_ADMIN, USER_TYPES.KITCHEN_WAITER, USER_TYPES.AUDITOR],
      },
      {
        title: 'navigation.sales-per',
        route: 'admin:reports:sales-per',
        svgIcon: 'icon-sales-per-items',
        userTypes: [USER_TYPES.BRANCH_ADMIN, USER_TYPES.KITCHEN_WAITER, USER_TYPES.AUDITOR],
      },
      {
        title: 'navigation.items-orders-report',
        svgIcon: 'icon-order-line-report',
        route: 'admin:reports:order-lines',
        userTypes: [USER_TYPES.BRANCH_ADMIN, USER_TYPES.KITCHEN_WAITER, USER_TYPES.AUDITOR],
      },
      {
        title: 'pos.sales-report',
        route: 'admin:reports:custom-report',
        svgIcon: 'icon-order-line-report',
        userTypes: [USER_TYPES.BRANCH_ADMIN],
      },
    ],
  },

]
